// URL base del backend (Vercel). Única fuente para todos los servicios.
export const API_BASE = "https://sananweb-jordi-san-andres-salvadors-projects.vercel.app";
